import { useState } from "react";

import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";

import { ConfirmDialog } from "primereact/confirmdialog";

import { GridType } from "../enums/sharedEnums.ts";

type ActionsProps = {
  downloadableUrl?: string;
  editUrl?: string;
  viewUrl?: string;
  order?: () => void;
  remove?: () => void;
  type: GridType;
  disabledInvoiceButton?: boolean;
  onCreateInvoice?: () => void;
};

const GridActionButtons = ({
  type,
  downloadableUrl,
  editUrl,
  viewUrl,
  disabledInvoiceButton,
  order,
  remove,
  onCreateInvoice,
}: ActionsProps) => {
  const [visibleDeleteConfirm, setVisibleDeleteConfirm] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(downloadableUrl!);
    toast.info("Lien du rapport copié dans le presse-papiers");
  };

  return (
    <div className="d-flex flex-row">
      <ConfirmDialog
        visible={visibleDeleteConfirm}
        onHide={() => setVisibleDeleteConfirm(false)}
        message="Voulez-vous réellement supprimer cet élément ?"
        header="Confirmation de suppression"
        icon="pi pi-exclamation-triangle"
        acceptClassName="p-button-danger"
        acceptLabel="Oui"
        rejectLabel="Non"
        accept={() => remove && remove()}
      />
      <div
        className="btn-action-group btn-group-sm"
        aria-label="btns-action-group"
      >
        {order && (
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            overlay={
              <Popover id="actionsComponentLink">
                <Popover.Body className="p-0 m-2 popoverTextSecondary">
                  <strong>Commander</strong>
                </Popover.Body>
              </Popover>
            }
          >
            <Button className="btn btn-actions" onClick={order}>
              <i className="bi bi-cart2 action-icon"></i>
            </Button>
          </OverlayTrigger>
        )}
        {viewUrl && (
          <>
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement={"bottom"}
              overlay={
                <Popover id="actionsComponentLink">
                  <Popover.Body className="p-0 m-2 popoverTextSecondary">
                    <strong>Consulter</strong>
                  </Popover.Body>
                </Popover>
              }
            >
              <Button
                className="btn btn-actions"
                onClick={() => {
                  window.open(viewUrl, "_blank");
                }}
              >
                <i className="bi bi-eye action-icon"></i>
              </Button>
            </OverlayTrigger>
          </>
        )}
        {onCreateInvoice && (
          <>
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement={"bottom"}
              overlay={
                <Popover id="actionsComponentLink">
                  <Popover.Body className="p-0 m-2 popoverTextSecondary">
                    <strong>Générer la facture</strong>
                  </Popover.Body>
                </Popover>
              }
            >
              <Button
                className="btn btn-actions"
                disabled={disabledInvoiceButton}
                onClick={onCreateInvoice}
              >
                <i className="bi bi-currency-euro action-icon"></i>
              </Button>
            </OverlayTrigger>
          </>
        )}
        {downloadableUrl && type === GridType.service && (
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            overlay={
              <Popover id="actionsComponentLink">
                <Popover.Body className="p-0 m-2 popoverTextSecondary">
                  <strong>Partager</strong>
                </Popover.Body>
              </Popover>
            }
          >
            <Button className="btn btn-actions" onClick={copy}>
              <i className="bi bi-link-45deg action-icon"></i>
            </Button>
          </OverlayTrigger>
        )}
        {editUrl && (
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            overlay={
              <Popover id="actionsComponentLink">
                <Popover.Body className="p-0 m-2 popoverTextSecondary">
                  <strong>Éditer</strong>
                </Popover.Body>
              </Popover>
            }
          >
            <Button
              className="btn btn-actions"
              onClick={() => {
                window.open(editUrl, "_blank");
              }}
            >
              <i className="bi bi-pencil-square action-icon"></i>
            </Button>
          </OverlayTrigger>
        )}

        {downloadableUrl && (
          <OverlayTrigger
            placement="bottom"
            trigger={["hover", "focus"]}
            overlay={
              <Popover id="actionsComponent">
                <Popover.Body className="p-0 m-2 popoverTextSecondary">
                  <strong>Télécharger</strong>
                </Popover.Body>
              </Popover>
            }
          >
            <Button
              className="btn btn-actions"
              variant="none"
              onClick={() => {
                location.href = downloadableUrl;
              }}
            >
              <i className="bi bi-file-earmark-arrow-down action-icon"></i>
            </Button>
          </OverlayTrigger>
        )}

        {remove && (
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            overlay={
              <Popover id="actionsComponentLink">
                <Popover.Body className="p-0 m-2 popoverTextSecondary">
                  <strong>Supprimer</strong>
                </Popover.Body>
              </Popover>
            }
          >
            <Button
              className="btn btn-actions"
              onClick={() => setVisibleDeleteConfirm(true)}
            >
              <i className="bi bi-trash3 action-icon"></i>
            </Button>
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

export default GridActionButtons;
